import { ref, type FirebaseStorage, deleteObject } from "firebase/storage";

export async function deleteFile({ path, storage }: { path: string; storage: FirebaseStorage }) {
  const fileRef = ref(storage, path);
  await deleteObject(fileRef);
}
